import React, { Component, Children } from 'react';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';

import styles from './slideshow.css';

class SlideShow extends Component {
  constructor(props) {
    super(props);

    this.state = {
      total: 0,
      current: 0
    }
  }

  componentDidMount() {
    const { children } = this.props;
    this.setState({ total: Children.count(children) });
    this.interval = setInterval(this.showNext, 8000);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  showNext = () => {
    const { total, current } = this.state;
    this.setState({
      current: current + 1 === total ? 0 : current + 1
    });
  };

  render() {
    const { children } = this.props;
    return (
      <div className={styles.slideShow}>
      <CSSTransitionGroup
        transitionName={styles}
        transitionEnterTimeout={5000}
        transitionLeaveTimeout={5000}>
          {Children.toArray(children)[this.state.current]}
        </CSSTransitionGroup>
      </div>
    );
  }
}

export default SlideShow;



// WEBPACK FOOTER //
// ./src/components/SlideShow/SlideShow.js